import { BackgroundHeading, Section, Heading } from '@tracklib/kit'
import styles from './headingblock.css'

type HeadingBlockProps = {
  value: {
    heading: string
    background_color: string
  }
}

const Wrapper = ({ children }: { children: JSX.Element }): JSX.Element => (
  <Section size="small" className={styles.section}>
    <div className={styles.wrapper}>{children}</div>
  </Section>
)

const HeadingBlock = ({ value: { heading, background_color } }: HeadingBlockProps): JSX.Element => {
  if (background_color) {
    return (
      <Wrapper>
        <BackgroundHeading color={background_color}>{heading}</BackgroundHeading>
      </Wrapper>
    )
  }
  return (
    <Wrapper>
      <Heading className={styles.heading}>{heading}</Heading>
    </Wrapper>
  )
}

export default HeadingBlock
